// extracted by mini-css-extract-plugin
module.exports = {"Architect":"Architect_Architect__1v-lt"};